<app-confirm-dialog
  *ngIf="showDialog"
  [message]="message"
  (commit)="onSubmit()"
  (cancel)="onCancel()"
></app-confirm-dialog>
